import React from 'react';
import { useAuth, pagesForRole } from '../context/AuthContext';

const NAV = [
  { key: 'agenda', label: 'Agenda', icon: '📅' },
  { key: 'clientes', label: 'Clientes', icon: '👥' },
  { key: 'inventario', label: 'Inventario', icon: '📦' },
  { key: 'notas', label: 'Notas de servicio', icon: '📝' },
  { key: 'usuarios', label: 'Usuarios', icon: '🔐' },
  { key: 'reportes', label: 'Reportes', icon: '📊' },
  { key: 'ajustes', label: 'Ajustes', icon: '⚙️' }
];

export default function Sidebar({ page, setPage }) {
  const { user } = useAuth();
  const allowed = pagesForRole(user.rol);

  return (
    <nav className="app-sidebar" style={{
      position: 'fixed', left: 0, top: 0, bottom: 0, width: 210,
      background: '#ffffff', borderRight: '1px solid #e2e8f0',
      paddingTop: 56 + 12, paddingBottom: 44 + 12,
      display: 'flex', flexDirection: 'column', gap: 2, zIndex: 100
    }}>
      <div className="side-title" style={{
        padding: '8px 16px 10px', fontSize: 11, fontWeight: 700,
        color: '#94a3b8', textTransform: 'uppercase', letterSpacing: 0.6
      }}>
        Menú
      </div>
      {NAV.filter(n => allowed.includes(n.key)).map(n => {
        const active = page === n.key;
        return (
          <button
            key={n.key}
            onClick={() => setPage(n.key)}
            style={{
              display: 'flex', alignItems: 'center', gap: 10,
              margin: '0 8px', padding: '10px 12px',
              background: active ? '#eff6ff' : 'transparent',
              color: active ? '#185fa5' : '#475569',
              border: 'none', borderRadius: 8,
              fontWeight: active ? 700 : 500, fontSize: 14, textAlign: 'left'
            }}
          >
            <span>{n.icon}</span>
            <span>{n.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
